import $ from 'jquery';

$(() => {
	$('.smart-tabs').find('dt.current').next('dd').addClass('current');
	$('.smart-tabs dt a').click(function(){
	$('.smart-tabs .current').each(function(){
		$(this).removeClass('current');
	});
	$(this).parent('dt').addClass('current').next('dd').addClass('current');
		return false;
	});
});